var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgPaperPlaneLight = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.813.296L1.062 17.959c-1.528.91-1.375 3.226.252 3.917l9.31 3.964v6.973c0 2.064 2.51 2.96 3.766 1.387l4.03-5.044 8.395 3.568c1.268.54 2.703-.287 2.909-1.689l4.25-28.51C34.246.698 32.34-.614 30.813.294zM12.75 32.813v-6.07l3.619 1.538-3.62 4.532zM27.625 30.7l-13.693-5.824L27.18 8.758c.319-.383-.192-.902-.564-.574L9.662 23.058 2.124 19.86 31.875 2.19l-4.25 28.512z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPaperPlaneLight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/paper-plane-light.3e42c6af.svg";
export { ForwardRef as ReactComponent };